<template>
  <div>
    <BasicSameLocationVideo
      :videofullsrc="videofullsrc"
      :videoposter="origin + videoposter"
      :videopostermob="origin + videopostermob"
      :playicon="origin + playicon"
      :maidiansuffix="maidiansuffix"
    />
  </div>
</template>
<script>
import BasicSameLocationVideo from '@/components/basic-samelocation-video.vue'
export default {
  components: {
    BasicSameLocationVideo
  },
  data() {
    return {
      origin: '',
      videofullsrc:'https://img.kia.cn/content/videos/20231114/E-GMP-Full.mp4',
      videoposter: '/assets/~/media/images/vehicle/newseltos/video/cover-pc.png',
      videopostermob: '/assets/~/media/images/vehicle/newseltos/video/cover-mob.png',
      playicon: '/assets/~/media/images/vehicle/newseltos/video/play-icon.png',
      maidiansuffix:'全新赛图斯视频'
    }
  },
  methods: {

  },
  mounted() {
    if (process.env.NODE_ENV == 'production') {
      this.origin = 'https://www.kia.cn'
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
